module.exports = __webpack_public_path__ + "app/img/origin.76512a7251.svg";